<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>

<main class="content-page bg-gray">
    @if (security.permitted('reports', 'automation log', 'view')) {
    <div class="content p-1">
        <div class="content text-dark">
            <div class="d-flex align-items-center">
                <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                    <ol class="breadcrumb text-capitalize text-dark h5">
                        <li class="breadcrumb-item"><a [routerLink]="['/reports']" class="text-secondary">Reports</a></li>
                        <li class="breadcrumb-item text-secondary" aria-current="page">Automation Log Report</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="col-md-12 p-1">
            <div class="rounded">
                <div class="list-bar">
                    <form [formGroup]="form" class="form-row">
                        <div class="form-group col">
                            <date-span [verb]="'Occurred'" [default]="FILTER_SPAN_KEY" [min]="'today'" [max]="'quarter'" (chosen)="spanned($event)"></date-span>
                        </div>
                        <div class="form-group col">
                            <select class="form-control" name="lot" id="lot-filter" formControlName="lot">
                                <option value="0">All Lots</option>
                                @for (lot of lots; track lot.id) {
                                    <option value="{{lot.id}}">{{lot.contact.name}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col">
                            <select class="form-control" name="type" id="type-filter" formControlName="type">
                                <option value="">All Types</option>
                                <option value="computeTerms">Receivables</option>
                                <option value="computeStats">Stats</option>
                                <option value="applyLateFees">Late Fees</option>
                            </select>
                        </div>
                    </form>
                </div>
                <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                    @if (entries) {
                    <table class="table table-sm table-hover table-striped table-responsive-sm" id="activityTable">
                        <thead>
                            <tr>
                                <th (click)="sort('saleDate')" class="sorted" scope="col">
                                    Started
                                    @if (sortedAsc('startedAt')) {
                                    <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                    }
                                    @if (sortedDesc('startedAt')) {
                                    <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                    }
                                </th>
                                <th scope="col">Status</th>
                                <th scope="col">Type</th>
                                <th scope="col">Lot</th>
                                <th scope="col">Detail</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entry of entries; track entry.id) {
                            <tr class="clickable text-dark" (click)="view(entry)">
                                <td>{{entry.startedAt | date:'E MMM d, yyyy h:mm:ss a'}}</td>
                                 <td>
                                    <span [class]="badgeClass(entry.status)">{{entry.status}}</span>
                                    @if (entry.errorMessage) {
                                        <p class="subtitle text-danger">{{entry.errorMessage}}</p>
                                    }
                                </td>
                                <td>{{entry.jobType}}</td>
                                <td>{{entry.lot}}</td>
                                <td>
                                    @if (entry.errorMessage) {
                                        <span class="text-danger">{{entry.errorMessage}}</span>
                                    }
                                    @else {
                                        {{entry.itemsProcessed | number:'1.0-0'}} item{{(entry.itemsProcessed > 1) ? 's' : ''}} in {{entry.duration | number:'1.0-0'}}ms
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                    }
                </div>
            </div>
            <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}} {{words[language]['displayed']}}</p>
        </div>
    </div>
}
</main>

<button class="d-none" data-target="#automation-log-meta-view" data-toggle="modal" id="btn-toggle-automation-meta-view"></button>
<div class="modal fade" id="automation-log-meta-view" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="automationLogMetaView">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Automation Log Detail</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span>&times;</span></button>
            </div>
            <div class="modal-body">
                <div id="meta-tab">
                    @if (copied) {
                        <span class="material-icons-outlined copy" (click)="clip($event)">done_all</span>
                    }
                    @else {
                        <span class="material-icons-outlined copy" (click)="clip($event)">content_copy</span>
                    }

                    <div class="detail"><pre>{{meta()}}</pre></div>
                </div>
            </div>
            <div class="modal-footer">
                @if (viewable) {
                    <p class="text-muted">{{viewable.completedAt || viewable.startedAt | date:'E MMM d, yyyy h:mm:ss a'}}</p>
                }
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
